import {
  CREATING_ATTACHMENT_TEMPLATE_FAILED,
  UPDATING_ATTACHMENT_TEMPLATE_FAILED,
  GETTING_ATTACHMENT_TEMPLATE_FAILED,
  GETTING_ATTACHMENT_TEMPLATES_FAILED,
  GETTING_MINIMAL_ATTACHMENT_TEMPLATES_FAILED,
  DELETING_ATTACHMENT_TEMPLATES_FAILED,
  GETTING_ASSOCIATED_CAMPAIGNS_FOR_ATTACHMENT_TEMPLATE_FAILED
} from 'store/attachmentTemplate/actions';

// TODO Get proper errors here

import { goToButton, dismissButton } from '../../helpers/error/buttonBuilders';
import {
  ATTACHMENT_TEMPLATE,
  ATTACHMENT_TEMPLATES
} from '../UserMessaging/userMessageDomains';

const attachmentTemplates = {
  [ATTACHMENT_TEMPLATES]: {
    [GETTING_ATTACHMENT_TEMPLATES_FAILED]: {
      userMessage: {
        instructions: 'Failed getting all attachments',
        buttons: [dismissButton()]
      }
    },

    [GETTING_MINIMAL_ATTACHMENT_TEMPLATES_FAILED]: {
      userMessage: {
        instructions: 'Failed getting minimal attachment templates',
        buttons: [dismissButton()]
      }
    },

    [GETTING_ASSOCIATED_CAMPAIGNS_FOR_ATTACHMENT_TEMPLATE_FAILED]: {
      userMessage: {
        instructions: 'Failed to archive attachment',
        buttons: [dismissButton()]
      }
    }
  }
};

const attachmentTemplate = {
  [ATTACHMENT_TEMPLATE]: {
    [GETTING_ATTACHMENT_TEMPLATE_FAILED]: {
      resource: 'attachmentTemplate',
      userMessage: {
        buttons: [goToButton('OK', '/attachment-templates')]
      }
    },

    [GETTING_ASSOCIATED_CAMPAIGNS_FOR_ATTACHMENT_TEMPLATE_FAILED]: {
      resource: 'attachmentTemplate',
      userMessage: {
        instructions: 'Failed to archive attachment',
        buttons: [dismissButton()]
      }
    },

    [UPDATING_ATTACHMENT_TEMPLATE_FAILED]: {
      resource: 'attachmentTemplate',
      userMessage: {
        instructions: 'Could not save attachment, please try again',
        buttons: [dismissButton()]
      }
    },

    [DELETING_ATTACHMENT_TEMPLATES_FAILED]: {
      resource: 'attachmentTemplate',
      userMessage: {
        instructions: 'Could not delete attachment, please try again',
        buttons: [dismissButton()]
      }
    },

    [CREATING_ATTACHMENT_TEMPLATE_FAILED]: {
      resource: 'attachmentTemplate',
      userMessage: {
        instructions: 'Could not save attachment, please try again',
        buttons: [dismissButton()]
      }
    }
  }
};

export default { ...attachmentTemplates, ...attachmentTemplate };
